import React from 'react'
import '../../../styles/chat/Chat.css'

export default function SkeletonConversation({ visibleChats = true }) {
    return (
        <div className="chat-conversations-container bg-[#ECEBF8]">
            <div className="chat-conversation-section">
                <div
                    className="conversation-header px-6 "
                    style={{
                        backgroundColor: visibleChats ? '#fafaff' : '#6693E432',
                        minHeight: '80px',
                    }}
                >
                    <div className="w-[60px] h-[60px] rounded-full bg-lightBG animate-pulse"></div>

                    <div className="flex flex-col space-y-2 flex-1 ml-[10px]">
                        <div className="h-4 bg-lightBG rounded" style={{ width: '150px' }} />
                        <div className="h-4 bg-lightBG rounded" style={{ width: '80px' }} />
                    </div>
                    <div className="flex flex-col items-end space-y-2">
                        <div className="h-4 bg-lightBG rounded" style={{ width: '80px' }} />
                        <div className="h-4 bg-lightBG rounded" style={{ width: '150px' }} />
                    </div>
                </div>

                <div className="conversation-main no-scroll px-6 flex-grow">
                    <div className="conversation-messages gap-3 ">
                        {[...Array(6)].map((_, index) => (
                            <div key={index} className={`flex min-h-[56px] w-full rounded-xl flex-1 ${index % 2 === 0 ? 'border border-lightBG bg-white' : 'bg-lightBG '} `}></div>
                        ))}
                    </div>
                    <div className="flex-1"></div>
                </div>

                <div className=" w-full  p-[10px] ">
                    <div className="min-h-[54px] flex flex-row items-center border border-lightBG rounded-full justify-between pl-4 pr-[6px]">
                        <div className="h-4 bg-lightBG rounded" style={{ width: '170px' }} />
                        <div className="w-[40px] h-[40px] rounded-full bg-deepPurple opacity-50 animate-pulse "></div>
                    </div>
                </div>
            </div>
        </div>
    )
}
